var categoriesParser = function categoriesParser() {
  var location = window.location;
  var pageCategory = ["", "", "", "", ""];
  var array = location.pathname.split("/").filter(function (element) {
    return element !== "";
  });

  if (array.length !== 0) {
    array.forEach(function (value, i) {
      if (i > 4 || value === "") return;
      var index = pageCategory.findIndex(function (element) {
        return element === "";
      });
      pageCategory[index] = pageCategoryNames[value] ? pageCategoryNames[value] : value;
    });
  } else {
    pageCategory[0] = "Home";
  }

  return pageCategory;
}; //Here to overwrite the default link name


export var pageCategoryNames = {
  menu: "eat",
  catering: "cater"
};
export default categoriesParser;